import React from 'react';
import { View } from "@/views/component/rules/style";

function Index() {
  return <View>
    {CONFIG.rule.map((item: string, index: number) => {
      return <p dangerouslySetInnerHTML={({ __html: item })} key={index}/>
    })}
  </View>
}

export default Index;
